/* src/app/components/payroll/invoices/provider/provider-invoice/provider-invoice.component.css */
:host ::ng-deep td.service-dates-cell,
:host ::ng-deep td.service-dates-cell .truncate-text {
  white-space: pre-line;
  overflow: visible;
  text-overflow: clip;
}
.import-invoice-dialog {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.import-invoice-dialog .dialog-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.import-invoice-dialog .dialog-text {
  font-size: 1rem;
  padding: 0;
  margin: 0;
  color: #333;
  line-height: 1.5;
}
.import-invoice-dialog .dialog-text.strong {
  font-weight: 600;
}
.import-invoice-dialog .dialog-hint {
  font-size: 0.875rem;
  color: #666;
}
.import-invoice-dialog .dialog-selected {
  font-size: 0.875rem;
  margin: 0;
  padding: 0;
  color: #303030;
}
.import-invoice-dialog .dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.import-invoice-dialog .file-upload {
  position: relative;
  width: fit-content;
}
.import-invoice-dialog .file-upload input[type=file] {
  display: none;
}
/*# sourceMappingURL=provider-invoice.component-MR7DXQ4D.css.map */
